// src/pages/Alert/AlertMessage.jsx
import React from 'react';
import './AlertMessage.css';

const AlertMessage = ({
  type = 'info',
  message,
  message2 = null, // nova prop para mensagem adicional
  icon = null, // 👈 nova prop
  onClose,
  onConfirm,
  okText = 'OK',
  cancelText = 'Cancelar',
}) => {
  return (
    <div className="alert-overlay">
      <div className="alert-box">

        {/* Cabeçalho do alerta com ícone + texto */}
        <div className="alert-message" style={{display: 'flex', alignItems: 'center', gap: '8px'}}>
          {icon && <span className="alert-icon" style={{    background: '#F2F4F7',borderRadius: '50%',padding: '9px 10px 4px 10px'}}>{icon}</span>}
          <span>{message}</span>
          {message2 ? <><br/><span style={{fontSize:'11px',position: 'absolute',bottom: '-12px',color: '#4595a5'}}>{message2}</span></> : null}
        </div>

        {/* Botões */}
        <div className="alert-buttons">
          {type === 'confirm' ? (
          <div style={{display:'flex',width: '100%',justifyContent: 'end'}}>

            <div style={{margin: '0px 5px 0px 0px'}}>
              <button className="btn btn-1" style={{padding: '7px 20px',background: 'transparent',color: '#344054',border: '1px solid #D0D5DD'}} onClick={onClose}>
                {cancelText}
              </button>
            </div>

            <div>
              <button
                className="btn btn-1"
                onClick={() => {
                  if (onConfirm) onConfirm();
                  onClose();
                }}
              >
              {okText}
              </button>
            </div>

  </div>
) : (
  <div style={{display:'flex',width: '100%',justifyContent: 'end'}}>
    <div>
  <button
    className="btn btn-1"
    onClick={() => {
      if (onConfirm) onConfirm(); // ✅ chama navigate aqui
      onClose();
    }}
  >
    {okText}
  </button>
  </div>
  </div>
)}
        </div>
      </div>
    </div>
  );
};

export default AlertMessage;